import * as yup from 'yup';
const dischargedQueueMemberFilterSchema = yup
    .object()
    .shape({
    organization_id: yup.string().trim()
})
    .defined();
export default dischargedQueueMemberFilterSchema;
